//Styles
import {  useState } from "react";
import { APP_KEY_IDS, FILE_EXPLORER_CONTENT_TYPE } from "../../constants/constants";
import BaseAppContainer from "../base--app-container/BaseAppContainer";
import Styles from "./Gallery.module.scss";
import LeftPanelMenu from "../left-panel-menu/LeftPanelMenu";
import Library from "./library/Library";
import NoImagePlaceholder from "./no-image/NoImagePlaceholder";


//Icons

import { ReactComponent as LibraryIcon } from "../../icons/extra_icons/gallery_library.svg"
import { ReactComponent as MemoriesIcon } from "../../icons/extra_icons/rewind.svg"
import { ReactComponent as PeopleIcon } from "../../icons/extra_icons/people.svg"
import { ReactComponent as PlacesIcon } from "../../icons/extra_icons/location.svg"
import { ReactComponent as RecentsIcon } from "../../icons/extra_icons/recent.svg"
import { ReactComponent as Favourites } from "../../icons/extra_icons/favourite.svg"
import { SPECIAL_ROUTE_HARACTER, getCurrentOption, gotoPreviousOption } from "../../global/functions/functrions";


//Redux
import handleLibraryImages from "../../reducers/gallery";
import { RootStateOrAny, useSelector } from "react-redux";
import ContentDialog from "../dialog-content/ContentDialog";




interface GalleryProps {
  activeTab?: "library" | "memories" | "people" | "recents" | "places" | "favourite"
}


interface ActiveImageTypes{
  id:string;
  index:number | undefined
}
const Gallery = ({ activeTab }: GalleryProps) => {

  const [activeImage, setActiveImage] = useState<any>({
    id:"",
    index:undefined
  })

  const [activeId, setActiveId] = useState<any>(activeTab || "library")

  const macLibraryImages = useSelector((state: RootStateOrAny) => state.handleLibraryImages)

  const onNextClick = () => {
    setActiveImage({
      id:Object.keys(macLibraryImages)[activeImage.index+1],
      index:activeImage.index != undefined ? activeImage.index + 1 : undefined
    });
  }
  const onPreviousClick = () => {
    setActiveImage({
      id:Object.keys(macLibraryImages)[activeImage.index-1],
      index:activeImage.index != undefined ? activeImage.index - 1 : undefined
    });
  }

  const onClickSetBackground = (imageLink: string) => {
    document.documentElement.style.setProperty(('--desktop-background-image'), "url(" + imageLink + ") no-repeat")
  }

  const leftMenu = [
    {
      label: "Photos",
      options: [
        {
          id: "library",
          label: "Library",
          icon: <LibraryIcon />
        },
        {
          id: "memories",
          label: "Memories",
          icon: <MemoriesIcon />
        },
        {
          id: "people",
          label: "People",
          icon: <PeopleIcon />
        },
        {
          id: "recents",
          label: "Recents",
          icon: <PlacesIcon />
        },
        {
          id: "places",
          label: "Places",
          icon: <RecentsIcon />
        },
        {
          id: "favourite",
          label: "Favourite",
          icon: <Favourites />
        }
      ]
    }
  ]

  const handleImageClick  = (id:string,index:number)=>{
      setActiveImage({
        id:id,
        index:index
      })
  }


  const getImagesPage = () => {
    switch (getCurrentOption(activeId)) {
      case "library": return <Library images={macLibraryImages} onClickImage={handleImageClick} />
      default: return <NoImagePlaceholder />
    }
  }

  const [forwardRef, setForwardRef] = useState("")


  const goBack = () => {
    setForwardRef(forwardRef + SPECIAL_ROUTE_HARACTER + activeId.split(SPECIAL_ROUTE_HARACTER)[activeId.split(SPECIAL_ROUTE_HARACTER).length - 1])
    setActiveId(gotoPreviousOption(activeId))
  }

  const goForward = () => {
    setActiveId(forwardRef ? activeId + forwardRef : activeId)
    setForwardRef(gotoPreviousOption(forwardRef))
  }




  return (
    <>
      <BaseAppContainer appId={APP_KEY_IDS.GALLERY}
        loadFromX={30}
        title={"Gallery"}
        onClickPreviousIcon={goBack}
        onClickNextIcon={goForward}
        SideBar={
          <LeftPanelMenu menuContent={leftMenu} activeValue={activeId} handleOptionClick={setActiveId} />
        }
        MainScreen={

          <div className={Styles.container}>

            {getImagesPage()}

          </div>

        }
        showHeader={true}
      />

      {
        activeImage.index != undefined && (

          <ContentDialog
            appId={"content_dialog"}
            loadFromX={60}
            loadFromY={500}
            title={`DISC_${("0" + (activeImage.index + 1)).slice(-5)}`}
            sourceLink={macLibraryImages[activeImage.id]}
            onPreviousClick={onPreviousClick}
            onNextClick={onNextClick}
            onClosedSuccessfully={setActiveImage}
            isPreviousIconVisible={activeImage.index!= 0}
            isNextIconVisible={activeImage.index != Object.keys(macLibraryImages).length-1}
            fileType={FILE_EXPLORER_CONTENT_TYPE.IMAGE}
          />
        )
      }
    </>

  )
}

export default Gallery
